import { render } from "./SupportHeader.vue?vue&type=template&id=38680b18"
import script from "./SupportHeader.vue?vue&type=script&lang=js"
export * from "./SupportHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__